import { BASE_API_URL } from '../apiConfig';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../components/ConfirmationModal';
import SocialLogin from '../components/SocialLogin';
import { useTranslation } from 'react-i18next';

const Login = () => {
    const { t } = useTranslation();
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const [email, setEmail] = useState(storedUser?.email || '');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [modalConfig, setModalConfig] = useState({ isOpen: false, message: '' });

    React.useEffect(() => {
        if (localStorage.getItem('token')) {
            navigate('/');
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await fetch(`${BASE_API_URL}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
        });
        const data = await res.json();
        if (res.ok) {
            localStorage.setItem('token', data.token);
            // Salva o aggiorna i dati dell'utente per la persistenza
            localStorage.setItem('user', JSON.stringify({
                ...data.user,
                email: email // Aggiungiamo l'email per il pre-filling futuro
            }));
            const redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
            localStorage.removeItem('redirectAfterLogin');
            navigate(redirectUrl);
        } else {
            setModalConfig({ isOpen: true, message: data.error || t('login_error') });
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <h2>{t('login_title')}</h2>
                    <p className="subtitle">{t('login_subtitle')}</p>
                </div>
                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label>{t('email')}</label>
                        <input 
                            type="email" 
                            placeholder="latua@email.com" 
                            value={email}
                            onChange={e => setEmail(e.target.value)} 
                            required 
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('password')}</label>
                        <input type="password" placeholder="••••••••" onChange={e => setPassword(e.target.value)} required />
                    </div>
                    <button type="submit" className="primary-btn">{t('enter')}</button>
                </form>
                <div className="auth-footer">
                    <p>{t('no_account')} <a href="/register">{t('register')}</a></p>
                </div>
                <SocialLogin setModalConfig={setModalConfig} />
            </div>
            
            <ConfirmationModal 
                isOpen={modalConfig.isOpen}
                onClose={() => setModalConfig({ isOpen: false, message: '' })}
                title={t('attention')}
                message={modalConfig.message}
                isAlert={true}
            />
        </div>
    );
};

export default Login;
